import { useSelector } from "react-redux";
import { getActiveChip } from "core-integration/src/store/chips/reducers";
import { RootState } from "core-integration/src/store";
import {
  getErrors,
  getProposedElements,
  getToSpend,
} from "core-integration/src/store/squad/reducers";
import { getElementTypesBySquadPosition } from "core-integration/src/store/element-types/reducers";

const useScoreboard = () => {
  const currencyDivisor = 10;
  const activeChip = useSelector(getActiveChip);

  const elementTypesByPosition = useSelector((state: RootState) =>
    getElementTypesBySquadPosition(state, undefined, activeChip?.id),
  );
  const proposedElements = useSelector((state: RootState) =>
    getProposedElements(state, undefined, activeChip?.id),
  );

  const toSpend = useSelector((state: RootState) =>
    getToSpend(state, undefined, activeChip?.id),
  );

  const errors = useSelector((state: RootState) =>
    getErrors(state, undefined, activeChip?.id),
  );

  const isNeedElements = Boolean(errors.needElements);
  const isBudgetExceeded = Boolean(errors.budgetExceeded);

  return {
    currencyDivisor,
    elementTypesByPosition,
    proposedElements,
    toSpend,
    isNeedElements,
    isBudgetExceeded,
  };
};

export default useScoreboard;
